import React from "react";
import {
  Dialog,
  DialogContent,
  DialogActions,
  Typography,
  makeStyles,
  Grid,
} from "@material-ui/core";
import Controls from "./controls/Controls";
import { useState } from "react";
import { useEffect } from "react";
import { getAllBanks, getAllPaymentMethods } from "../../../services";
import { Form, useForm } from "./useForm";
import axios from "axios";
import * as sweetalert from "sweetalert";
import packageJson from "../../../../package.json";
import { getEPaymentConfig } from "../../../services/EPaymentConfig";
import { WindowScrollController } from "@fullcalendar/core";
export const BaseUrl = packageJson.projectURlApi.BaseUrl;
const useStyles = makeStyles((theme) => ({
  dialog: {
    padding: theme.spacing(4),
    position: "absolute",
    top: theme.spacing(5),
  },
  dialogTitle: {
    textAlign: "center",
  },
  dialogContent: {
    textAlign: "center",
    flex:0.1 ,
  
  },
  dialogAction: {
    justifyContent: "center",
  },
  titleIcon: {
    backgroundColor: theme.palette.secondary.light,
    color: theme.palette.secondary.main,
    "&:hover": {
      backgroundColor: theme.palette.secondary.light,
      cursor: "default",
    },
    "& .MuiSvgIcon-root": {
      fontSize: "8rem",
    },
  },
}));

export default function ConfirmDialog(props) {
  const [paymentMethod, setPaymentMethod] = useState([]);
  const [Banks, setBanks] = useState([]);

  const { confirmDialog, setConfirmDialog } = props;
  const classes = useStyles();
  const staff_type = localStorage.getItem("staff_type");
  const [loading, setLoading] = useState(false);
  const [Paymentconfigration, setGetPaymentconfigration] = useState([]);
  useEffect(() => {}, [props.id]);

  useEffect(() => {
    getAllPaymentMethods().then((res) => {
      setPaymentMethod(res.data);
    });
    getAllBanks().then((res) => {
      setBanks(res);
    });
    getEPaymentConfig().then((res) => {
      setGetPaymentconfigration(res);
      
    });
    return () => {};
  }, []);
 
  const initialFValues = {
    mobile_number: props.phone,
  };
  const validate = (fieldValues = loginInput) => {
    let temp = { ...errors };

  

    setErrors({
      ...temp,
    });
    if (fieldValues == loginInput)
      return Object.values(temp).every((x) => x == "");
  };
  
  const { loginInput, setLogin, errors, setErrors, handleInputChange } =
    useForm(initialFValues, true.validate);

    const handleSubmit = (e) => {
      e.preventDefault();
      setLoading(true);
      if (validate()) {
        const data = {
          mobile_number: initialFValues.mobile_number,
        };
    
        axios
          .post(`${BaseUrl}/api/addToMyCustomerLiretna`, data, {
            withCredentials: true,
          })
          .then((res) => {
            if (res.data.status === true) {
              setLoading(false);
              localStorage.setItem("distrbutor_mobile", initialFValues.mobile_number);
              sweetalert(res.data.msg, {
                className: "alert-div",
                button: {
                  text: "تم",
                },
              }).then(() => {
                // window.location.reload();
              });
            } else {
              setLoading(false);
              // API responded with status false, showing the error message.
              sweetalert(res.data.msg, {
                className: "alert-div",
                button: {
                  text: "تم",
                },
              });
            }
          })
          .catch((error) => {
            // Handle errors here
            setLoading(false);
            if (error.response) {
              if (Array.isArray(error.response.data.data) && error.response.data.data.length > 0) {
                // Display the first error message from the data array
                
                sweetalert(error.response.data.data[0], {
                  className: "alert-div",
                  button: {
                    text: "OK",
                  },
                });
              } 
           if(error.response.status == 422) {
            setLoading(false);
              // The request was made but no response was received
              sweetalert(error.response.data.msg, {
                className: "alert-div",
                button: {
                  text: "تم",
                },
              });
            }
          }  
        })
        
        
          // .catch((error) => {
          //   // Handle errors here
          //   if (error.response) {
          //     if (Array.isArray(error.response.data.data) && error.response.data.data.length > 0) {
          //       // Display the first error message from the data array
          //       sweetalert(error.response.data.data[0], {
          //         className: "alert-div",
          //         button: {
          //           text: "OK",
          //         },
          //       });
          //     } 
          //   } else if (error.request) {
          //     // The request was made but no response was received
          //     sweetalert("No response was received from the server", {
          //       className: "alert-div",
          //       button: {
          //         text: "OK",
          //       },
          //     });
          //   } else {
          //     // Something happened in setting up the request that triggered an Error
          //     sweetalert("Error setting up the request", {
          //       className: "alert-div",
          //       button: {
          //         text: "OK",
          //       },
          //     });
          //   }
          // });
      }
    };
    
  // const handleSubmit = (e) => {
  //   e.preventDefault();

  //   if (validate()) {
  //     const data = {
  //       mobile_number: initialFValues.mobile_number,
  //     };

  //     axios
  //       .post(`${BaseUrl}/api/addToMyDistributor`, data, {
  //         withCredentials: true,
  //       })
  //       .then((res) => {
  //         if (res.data.status == true) {
  //           localStorage.setItem("convert_mobile",initialFValues.mobile_number);
  //           sweetalert(res.data.msg, {
  //             className: "alert-div",
  //             button: {
  //               text: "تم",
  //             },
  //           }).then(() => {
  //           window.location.reload();
  //           })
  //         } else if (res.data.status == false) {
  //           sweetalert(res.data.msg, {
  //             className: "alert-div",
  //             button: {
  //               text: "تم",
  //             },
  //           });
  //         } else {
  //           sweetalert(loginInput.error_list);
  //           setLogin({ ...loginInput, error_list: res.data.message });
  //         }
  //       });
  //   }
  // };
 
  return (
    <Dialog open={confirmDialog.isOpen} classes={{ paper: classes.dialog }}>
      <DialogContent className={classes.dialogContent}>
        <Typography variant="h6">{confirmDialog.title}</Typography>
        <Typography variant="subtitle2">{confirmDialog.subTitle}</Typography>
      </DialogContent>
      <DialogActions
        className={classes.dialogAction}
        style={{ display: "flex", flexDirection: "column" }}
      >
        <Form className="form-group new-design" onSubmit={handleSubmit}>
          <Grid item lg={12} md={12} xs={12}>
            <Grid item md={12} xs={12}>
              <Controls.Input
                label="رقم الموبايل"
                name="mobile_number"
                variant="outlined"
                fullWidth
                onChange={handleInputChange}
                className="form-control"
                value={initialFValues.mobile_number}
                disabled
              />
            </Grid>
       
          </Grid>
          <Grid item lg={12} md={12} xs={12} style={{ marginTop: "15px" }}>
            <Controls.Button
              text="تراجع"
              color="default"
              onClick={() =>
                setConfirmDialog({ ...confirmDialog, isOpen: false })
              }
            />
            {loading === true ? (
              <Controls.Button
                type="submit"
                text=<div class="spinner center">
                  <div class="spinner-blade"></div>
                  <div class="spinner-blade"></div>
                  <div class="spinner-blade"></div>
                  <div class="spinner-blade"></div>
                  <div class="spinner-blade"></div>
                  <div class="spinner-blade"></div>
                  <div class="spinner-blade"></div>
                  <div class="spinner-blade"></div>
                  <div class="spinner-blade"></div>
                  <div class="spinner-blade"></div>
                  <div class="spinner-blade"></div>
                  <div class="spinner-blade"></div>
                </div>
                variant="contained"
                className="btn-submit loader-submit "
              ></Controls.Button>
            ) : (
              <>
               
                  <Controls.Button
                    text="إضافة"
                    color="secondary"
                    onClick={handleSubmit}
                  />
               
              </>
            )}
          </Grid>
        </Form>
      </DialogActions>
    </Dialog>
  );
}
